export const genericPlaceholders = {
    bankAccount: $localize`:@@generic.placeholder.bank-account:NL01ABNA0123456789`,
    emailAddress: $localize`:@@generic.placeholder.email-address:E-mail address`,
    password: $localize`:@@generic.placeholder.password:Password`,

};
